import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopbarComponent } from './topbar/topbar.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LayoutComponent } from './layout.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { RouterModule } from '@angular/router';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { CustomerPrivacyModule } from './customer-privacy/customer-privacy.module';
import { FormsModule } from '@angular/forms';
import { SearchModule } from './topbar/search/search.module';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileModule } from './topbar/profile/profile.module';
import { DevelopmentModule } from 'shared/development/development.module';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { CeAccessModule } from 'shared/access/access.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { LicenseNamePipeModule } from 'shared/pipes/license-name/license-name-pipe.module';
import { ReleaseInfoComponent } from './topbar/release-info/release-info.component';
import { TimeDisplayModule } from 'shared/time-display/time-display.module';

@NgModule({
    declarations: [TopbarComponent, SidenavComponent, LayoutComponent, ReleaseInfoComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatIconModule,
        MatButtonModule,
        RouterModule,
        FormsModule,
        MatSlideToggleModule,
        CustomerPrivacyModule,
        TranslateModule,
        MatMenuModule,
        SearchModule,
        ProfileModule,
        DevelopmentModule,
        MatProgressBarModule,
        CeAccessModule,
        MatTooltipModule,
        LicenseNamePipeModule,
        TimeDisplayModule,
    ],
    exports: [LayoutComponent],
})
export class LayoutModule {}
